import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@ui/atoms/utils/utils';

const loadingVariants = cva('', {
    variants: {
        variant: {
            primary: 'text-primary-500 border-primary-600',
            secondary: 'text-basicWhite border-basicWhite',
        },
    },
    defaultVariants: {
        variant: 'primary',
    },
});

const Loading = ({
    loadText = 'things',
    textVisible = true,
    variant = 'primary',
}) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center w-full h-full'
            )}
        >
            <div
                className={`w-12 h-12 mb-4 border-b-4 rounded-full animate-spin ${loadingVariants(
                    { variant }
                )}`}
            ></div>
            {textVisible && (
                <div className="flex items-baseline">
                    <div
                        className={`mr-2 text-base font-semibold md:text-lg ${loadingVariants(
                            { variant }
                        )}`}
                    >
                        {`Getting your ${loadText} ready`}
                    </div>
                    {[100, 200, 300].map((delay, index) => (
                        <div
                            key={index}
                            className={cn(
                                `relative w-[6px] h-[6px] mr-1 rounded-full bg-primary-500 animate-bounce`,
                                {
                                    'bg-basicWhite': variant !== 'primary',
                                }
                            )}
                            style={{ animationDelay: `${delay}ms` }}
                        ></div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Loading;
